<template>
  <div v-if="loading" class="skeleton-loader-wrapper">
    <SkeletonLoader :loadingText="loadingText" />
  </div>
  <div v-else class="edit-category-budget-view">
    <MainHeader :title="'Category Budget'">
      <template #left>
        <font-awesome-icon
          @click="router.push({ name: 'Budget' })"
          :icon="['fas', 'arrow-left-long']"
          class="pointer"
        />
      </template>
    </MainHeader>

    <div class="view ecb-view">
      <div class="et-tabs">
        <button
          class="et-tab"
          :class="{ active: !editCategoryBudgetSliderSelected }"
          @click="editCategoryBudgetSliderSelected = false"
        >
          Info
        </button>
        <button
          class="et-tab"
          :class="{ active: editCategoryBudgetSliderSelected }"
          @click="editCategoryBudgetSliderSelected = true"
        >
          Edit
        </button>
      </div>

      <div v-if="!editCategoryBudgetSliderSelected">
        <div class="ec-hero">
          <div
            class="ec-hero-icon"
            :style="{
              background:
                (store.editCategoryBudget.iconColor || '#7F77DD') + '22',
            }"
          >
            <font-awesome-icon
              v-if="store.editCategoryBudget.icon"
              :icon="parseIconString(store.editCategoryBudget.icon)"
              :style="{ color: store.editCategoryBudget.iconColor }"
              style="font-size: 28px"
            />
            <font-awesome-icon
              v-else
              :icon="['fas', 'tag']"
              style="font-size: 28px; color: #7f77dd"
            />
          </div>
          <h2 class="ec-hero-name">{{ store.editCategoryBudget.name }}</h2>
        </div>

        <div class="wrapper-card ec-info-card">
          <div class="ud-section">
            <span class="section-label">Budget details</span>
            <div class="et-info-row">
              <span class="et-info-label">Category</span>
              <span class="et-info-value">{{
                store.editCategoryBudget.name
              }}</span>
            </div>
            <div class="et-info-row">
              <span class="et-info-label">Budget</span>
              <span class="et-info-value">{{
                formatMoneyInput(store.editCategoryBudget.budget)
              }}</span>
            </div>
          </div>

          <div
            class="ud-section"
            v-if="
              Object.prototype.hasOwnProperty.call(
                store.editCategoryBudget,
                'subcategories'
              )
            "
          >
            <span class="section-label">Subcategories</span>
            <div
              v-if="
                store.editCategoryBudget.subcategories &&
                store.editCategoryBudget.subcategories.length > 0
              "
            >
              <div
                v-for="item in store.editCategoryBudget.subcategories"
                :key="item"
                class="sub-budget-row"
              >
                <div class="sub-budget-icon">
                  <font-awesome-icon
                    :icon="parseIconString(item.icon)"
                    :style="{ color: item.iconColor }"
                    style="font-size: 13px"
                  />
                </div>
                <span class="sub-budget-name">{{ item.name }}</span>
                <div class="sub-budget-right">
                  <span class="sub-budget-value">{{
                    formatMoneyInput(item.budget)
                  }}</span>
                  <span class="sub-budget-label">Budget</span>
                </div>
              </div>
            </div>
            <p v-else class="ec-empty-text">No subcategories</p>
          </div>
        </div>
      </div>

      <div v-else>
        <div class="ud-section">
          <span class="section-label">Category budget</span>

          <div class="ud-field">
            <label class="ud-label">Category Name</label>
            <div class="ud-readonly">{{ categoryName }}</div>
          </div>

          <div class="ud-field mt">
            <label class="ud-label" for="categoryBudget">Budget Amount</label>
            <input
              type="text"
              class="ud-input"
              id="categoryBudget"
              :placeholder="store.editCategoryBudget.budget"
              v-model="categoryBudget"
            />
          </div>
        </div>

        <div
          class="ud-section"
          v-if="
            store.editCategoryBudget.subcategories &&
            store.editCategoryBudget.subcategories.length > 0
          "
        >
          <span class="section-label">Subcategory budgets</span>
          <div
            v-for="subcategory in store.editCategoryBudget.subcategories"
            :key="subcategory"
            class="sub-edit-row"
          >
            <div class="sub-edit-icon">
              <font-awesome-icon
                :icon="parseIconString(subcategory.icon)"
                :style="{ color: subcategory.iconColor }"
                style="font-size: 13px"
              />
            </div>
            <span class="sub-edit-name">{{ subcategory.name }}</span>
            <div class="sub-edit-input">
              <input
                type="text"
                :value="subcategory.budget"
                class="ud-input sub-budget-input"
                :placeholder="subcategory.budget"
                @input="
                  (e) => updateSubcategoryBudget(subcategory, e.target.value)
                "
              />
              <!-- <input
                type="text"
                v-model="subcategory.budget"
                class="ud-input sub-budget-input"
                :placeholder="subcategory.budget"
                @input="
                  (e) => updateSubcategoryBudget(subcategory, e.target.value)
                "
              /> -->
            </div>
          </div>
        </div>

        <button
          class="ud-submit"
          @click="updateCategory"
          data-pt-name="update category budget"
        >
          Update Budget
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useMyStore } from '../store';
import { useRouter } from 'vue-router';
import { ref, onUnmounted, onMounted } from 'vue';
import MainHeader from '../components/View-Header.vue';
import { formatMoneyInput } from '../utils/formValidation/formatMoneyInput.js';
import SkeletonLoader from '../components/SkeletonLoader.vue';

export default {
  components: { MainHeader, SkeletonLoader },
  setup() {
    const store = useMyStore();
    const router = useRouter();

    let editCategoryBudgetSliderSelected = ref(false);
    const categoryName = ref(store.editCategoryBudget.name);
    let categoryBudget = ref();
    let updatedCategory = {};
    let loading = ref(true);
    let loadingText = ref('Loading...');

    const parseIconString = (iconString) => {
      if (iconString) {
        const [category, icon] = iconString.split(' ');
        return [category, icon];
      }
      return null;
    };

    const formatMoney = (e) => {
      if (isNaN(e.target.value)) return '';
      const formattedValue = Number(e.target.value).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
      });
      categoryBudget.value = formattedValue;
      return formattedValue;
    };

    const formatMoneyRegex = (e) => {
      let numericValue = e.target.value.replace(/[^0-9.]/g, '');
      let formattedValue = '$' + numericValue;
      formattedValue = formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      let addCents = formattedValue.replace(/^(\d+)(\d{2})$/, '$1.$2');
      categoryBudget.value = addCents;
      return addCents;
    };

    // const updateCategory = () => {
    //   loadingText.value = 'Updating Category...';
    //   loading.value = true;
    //   updatedCategory.Budget = categoryBudget.value
    //     ? categoryBudget.value
    //     : store.editCategoryBudget.budget;

    //   if (Object.prototype.hasOwnProperty.call(store.editCategoryBudget, 'subcategoryID')) {
    //     store.saveSubcategoryBudgetDataForMonth(updatedCategory).then(() => {
    //       store.updateEditCategoryBudget({}, null, null);
    //       loading.value = false;
    //       router.push({ name: 'Budget' });
    //     });
    //   } else {
    //     store.saveCategoryBudgetDataForMonth(updatedCategory).then(() => {
    //       store.updateEditCategoryBudget({}, null, null);
    //       loading.value = false;
    //       router.push({ name: 'Budget' });
    //     });
    //   }
    // };

    // const updateCategory = () => {
    //   loadingText.value = 'Updating Category...';
    //   loading.value = true;
    //   updatedCategory.Budget = categoryBudget.value
    //     ? categoryBudget.value
    //     : store.editCategoryBudget.budget;

    //   if (
    //     Object.prototype.hasOwnProperty.call(
    //       store.editCategoryBudget,
    //       'subcategoryID'
    //     )
    //   ) {
    //     store.saveSubcategoryBudgetDataForMonth(updatedCategory).then(() => {
    //       loading.value = false;
    //       router.push({ name: 'Budget' });
    //     });
    //   } else {
    //     store.saveCategoryBudgetDataForMonth(updatedCategory).then(() => {
    //       loading.value = false;
    //       router.push({ name: 'Budget' });
    //     });
    //   }
    // };

    const updateCategory = async () => {
      loadingText.value = 'Updating Category...';
      loading.value = true;

      // updatedCategory.Budget = categoryBudget.value
      //   ? categoryBudget.value
      //   : store.editCategoryBudget.budget;

      updatedCategory.Budget = categoryBudget.value
        ? parseFloat(categoryBudget.value)
        : parseFloat(store.editCategoryBudget.budget);

      try {
        if (
          Object.prototype.hasOwnProperty.call(
            store.editCategoryBudget,
            'subcategoryID'
          )
        ) {
          await store.saveSubcategoryBudgetDataForMonth(updatedCategory);
        } else {
          await store.saveCategoryBudgetDataForMonth(updatedCategory);
        }
        router.push({ name: 'Budget' });
      } catch (error) {
        console.error('Error updating category budget:', error);
      } finally {
        loading.value = false;
      }
    };

    const updateSubcategoryBudget = (subcategory, value) => {
      const subcategoryIndex = updatedCategory.Subcategories.findIndex(
        (item) => item.SubcategoryID === subcategory.subcategoryID
      );
      if (subcategoryIndex !== -1) {
        updatedCategory.Subcategories[subcategoryIndex].Budget = value;
      } else {
        updatedCategory.Subcategories.push({
          SubcategoryID: subcategory.subcategoryID,
          Name: subcategory.name,
          Budget: value,
          ParentCategoryID: subcategory.parentCategoryID,
          Month: store.editCategoryMonth,
          Year: store.editCategoryYear,
        });
      }
    };

    onMounted(() => {
      setTimeout(() => {
        const mainElement = document.querySelector('.main');
        if (mainElement) mainElement.scrollTo(0, 0);
      }, 100);

      categoryBudget.value = store.editCategoryBudget.budget;
      if (
        Object.prototype.hasOwnProperty.call(
          store.editCategoryBudget,
          'subcategoryID'
        )
      ) {
        updatedCategory = {
          SubcategoryID: store.editCategoryBudget.subcategoryID,
          parentCategoryID: store.editCategoryBudget.parentCategoryID,
          Name: store.editCategoryBudget.name,
          Month: store.editCategoryMonth,
          Year: store.editCategoryYear,
          Budget: categoryBudget.value,
        };
      } else {
        updatedCategory = {
          CategoryID: store.editCategoryBudget.categoryID,
          Name: store.editCategoryBudget.name,
          Month: store.editCategoryMonth,
          Year: store.editCategoryYear,
          Budget: categoryBudget.value,
          Subcategories: [],
        };
      }
      loading.value = false;
    });

    onUnmounted(() => {
      store.updateEditCategory({});
    });

    return {
      store,
      router,
      editCategoryBudgetSliderSelected,
      parseIconString,
      categoryName,
      formatMoneyInput,
      formatMoney,
      categoryBudget,
      formatMoneyRegex,
      updateCategory,
      updateSubcategoryBudget,
      loading,
      loadingText,
    };
  },
};
</script>

<style scoped>
.ecb-view {
  max-width: 480px;
  margin: 0 auto;
}

.et-tabs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-bottom: 1.5rem;
  background: #f0f0f4;
  border-radius: var(--radius-pill);
  padding: 4px;
}
.dark-theme .et-tabs {
  background: #1a2535;
}

.et-tab {
  border: none;
  border-radius: var(--radius-pill);
  padding: 0.6rem;
  font-family: 'Poppins', sans-serif;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  background: transparent;
  color: #888;
  transition: all 0.2s ease;
}
.et-tab.active {
  background: linear-gradient(135deg, #7f77dd, #5dcaa5);
  color: white;
  box-shadow: 0 4px 12px rgba(127, 119, 221, 0.3);
}

.ec-hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem 0 1.25rem;
  animation: slideUp 0.4s ease both;
}
.ec-hero-icon {
  width: 72px;
  height: 72px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.75rem;
  animation: popIn 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) 0.1s both;
}
.ec-hero-name {
  font-size: 1.3rem;
  font-weight: 700;
  color: #004751;
  margin: 0;
  letter-spacing: -0.02em;
  text-align: center;
}
.dark-theme .ec-hero-name {
  color: white;
}

.ec-info-card {
  animation: cardSlideUp 0.4s cubic-bezier(0.34, 1.2, 0.64, 1) both;
}

.et-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.6rem 0;
  border-bottom: 1px solid #f0f0f0;
}
.dark-theme .et-info-row {
  border-bottom-color: #2a3a4e;
}
.et-info-row:last-child {
  border-bottom: none;
}
.et-info-label {
  font-size: 0.78rem;
  font-weight: 600;
  color: #888;
}
.et-info-value {
  font-size: 0.82rem;
  font-weight: 500;
  color: #213547;
  text-align: right;
}
.dark-theme .et-info-value {
  color: #d4d2d2;
}

.sub-budget-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0.6rem 0;
  border-bottom: 1px solid #f0f0f0;
}
.dark-theme .sub-budget-row {
  border-bottom-color: #2a3a4e;
}
.sub-budget-row:last-child {
  border-bottom: none;
}
.sub-budget-icon {
  width: 28px;
  height: 28px;
  border-radius: 7px;
  background: #f4f4f8;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.dark-theme .sub-budget-icon {
  background: #1a2535;
}
.sub-budget-name {
  flex: 1;
  font-size: 0.82rem;
  font-weight: 500;
  color: #515a65;
}
.dark-theme .sub-budget-name {
  color: #d4d2d2;
}
.sub-budget-right {
  text-align: right;
}
.sub-budget-value {
  display: block;
  font-size: 0.88rem;
  font-weight: 600;
  color: #213547;
}
.dark-theme .sub-budget-value {
  color: #d4d2d2;
}
.sub-budget-label {
  display: block;
  font-size: 0.68rem;
  color: #aaa;
}

.ec-empty-text {
  font-size: 0.78rem;
  color: #aaa;
  margin: 0.5rem 0 0;
  font-style: italic;
}

.ud-readonly {
  font-size: 0.88rem;
  font-weight: 600;
  color: #213547;
  padding: 10px 0 4px;
}
.dark-theme .ud-readonly {
  color: #d4d2d2;
}

.sub-edit-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0.6rem 0;
  border-bottom: 1px solid #f0f0f0;
}
.dark-theme .sub-edit-row {
  border-bottom-color: #2a3a4e;
}
.sub-edit-row:last-child {
  border-bottom: none;
}
.sub-edit-icon {
  width: 28px;
  height: 28px;
  border-radius: 7px;
  background: #f4f4f8;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.dark-theme .sub-edit-icon {
  background: #1a2535;
}
.sub-edit-name {
  flex: 1;
  font-size: 0.82rem;
  font-weight: 500;
  color: #515a65;
}
.dark-theme .sub-edit-name {
  color: #d4d2d2;
}
.sub-edit-input {
  width: 100px;
  flex-shrink: 0;
}
.sub-budget-input {
  text-align: right;
  padding: 8px 10px;
  font-size: 0.82rem;
}

.icon-wrapper svg {
  display: block;
  position: relative;
  font-size: 14px;
  line-height: 30px;
}
.dark-theme .icon-wrapper:before {
  background: #212e3e;
}
</style>

<!-- <template>
  <div v-if="loading" class="skeleton-loader-wrapper">
    <SkeletonLoader :loadingText="loadingText" />
  </div>
  <div v-else>
    <MainHeader :title="'Category Budget'">
      <template #left>
        <font-awesome-icon
          @click="router.push({ name: 'Budget' })"
          :icon="['fas', 'arrow-left-long']"
          class="pointer"
        />
      </template>
    </MainHeader>
    <div class="view">
      <div>
        <Slider
          :options="sliderOptions"
          @sliderSelection="sliderOptionUpdated($event)"
        ></Slider>
      </div>
      <div class="add-category-form" v-if="editCategoryBudgetSliderSelected">
        <div class="text-center pt-4 pb-4">
          <font-awesome-icon
            :icon="['fas', 'folder-open']"
            class="view-icon info-icon"
          />
        </div>
        <div class="mt-1">
          <label class="small-grey-text">Category Name</label>
        </div>
        <div>
          {{ categoryName }}
        </div>
        <div class="mt-1">
          <label class="small-grey-text">Category Budget</label>
          <div>
            <input
              type="text"
              class="input"
              :placeholder="store.editCategoryBudget.budget"
              v-model="categoryBudget"
            />
          </div>
        </div>
        <div
          class="mt-1"
          v-if="
            store.editCategoryBudget.subcategories &&
            store.editCategoryBudget.subcategories.length > 0
          "
        >
          <label class="small-grey-text">Subcategories</label>
          <div>
            <div
              v-for="subcategory in store.editCategoryBudget.subcategories"
              :key="subcategory"
              class="flex align-center mb-1 subcategory-item"
            >
              <div class="icon-wrapper d-flex justify-center align-center">
                <font-awesome-icon
                  :icon="parseIconString(subcategory.icon)"
                  :style="{ color: subcategory.iconColor }"
                  class="subcategory-icon subcategory-icon-width"
                />
              </div>
              <div class="ms-1 subcategory-name-width">
                {{ subcategory.name }}
              </div>
              <div class="subcategory-budget-width">
                {{ index }}
                <div class="budget-value">
                  <input
                    type="text"
                    v-model="subcategory.budget"
                    class="input"
                    :placeholder="subcategory.budget"
                    @input="
                      (e) =>
                        updateSubcategoryBudget(subcategory, e.target.value)
                    "
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-4">
          <button
            class="blue-button mt-1 w-100"
            @click="updateCategory"
            data-pt-name="update category budget"
            data-pt-property-category="update category budget"
          >
            Update Category
          </button>
        </div>
      </div>
      <div v-else>
        <div class="text-center pt-4 pb-4">
          <font-awesome-icon
            :icon="['fas', 'folder']"
            class="view-icon info-icon"
          />
        </div>
        <div class="cat-info-card">
          <div class="mt-1">
            <label class="small-grey-text">Category Name</label>
            <div>
              {{ store.editCategoryBudget.name }}
            </div>
          </div>
          <div class="mt-1">
            <label class="small-grey-text">Category Budget</label>
            <div>
              {{ formatMoneyInput(store.editCategoryBudget.budget) }}
            </div>
          </div>
          <div
            class="mt-1"
            v-if="
              Object.prototype.hasOwnProperty.call(
                store.editCategoryBudget,
                'subcategories'
              )
            "
          >
            <label class="small-grey-text">Subcategories</label>
            <div class="subcategorization-card">
              <div class="subcategory-list-wrapper">
                <div
                  v-if="
                    store.editCategoryBudget.subcategories &&
                    store.editCategoryBudget.subcategories.length > 0
                  "
                >
                  <div
                    v-for="item in store.editCategoryBudget.subcategories"
                    :key="item"
                    class="flex align-center mb-1 subcategory-item"
                  >
                    <div
                      class="icon-wrapper d-flex justify-center align-center"
                    >
                      <font-awesome-icon
                        :icon="parseIconString(item.icon)"
                        :style="{ color: item.iconColor }"
                        class="subcategory-icon subcategory-icon-width"
                      />
                    </div>
                    <div class="ms-1 subcategory-name-width">
                      {{ item.name }}
                    </div>
                    <div class="subcategory-budget-width">
                      <div class="budget-value">
                        {{ formatMoneyInput(item.budget) }}
                      </div>
                      <div class="budget-text transaction-grey">Budget</div>
                    </div>
                  </div>
                </div>
                <div v-else>No subcategories</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useMyStore } from '../store';
import { useRouter } from 'vue-router';
import { ref, onUnmounted, onMounted } from 'vue';

import MainHeader from '../components/View-Header.vue';
import Slider from '../components/Slider.vue';
import { Edit_Category_Types } from '../utils/constants.js';
import { formatMoneyInput } from '../utils/formValidation/formatMoneyInput.js';
import SkeletonLoader from '../components/SkeletonLoader.vue';

export default {
  components: {
    MainHeader,
    Slider,
    SkeletonLoader,
  },
  setup() {
    const store = useMyStore();
    const router = useRouter();
    const sliderOptions = [
      { label: 'Info', disabled: false },
      { label: 'Edit', disabled: true },
    ];
    let editCategoryBudgetSliderSelected = ref(false);
    const categoryName = ref(store.editCategoryBudget.name);
    let categoryBudget = ref();
    let updatedCategory = {};
    let loading = ref(true);
    let loadingText = ref('Loading...');

    const sliderOptionUpdated = (selection) => {
      if (selection === Edit_Category_Types.edit) {
        editCategoryBudgetSliderSelected.value = true;
      } else {
        editCategoryBudgetSliderSelected.value = false;
      }
    };

    const parseIconString = (iconString) => {
      if (iconString) {
        const [category, icon] = iconString.split(' ');
        return [category, icon];
      }
      return null;
    };

    const formatMoney = (e) => {
      if (isNaN(e.target.value)) {
        return '';
      }
      const formattedValue = Number(e.target.value).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
      });
      categoryBudget.value = formattedValue;
      return formattedValue;
    };

    const formatMoneyRegex = (e) => {
      let numericValue = e.target.value.replace(/[^0-9.]/g, '');
      let formattedValue = '$' + numericValue;
      formattedValue = formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      let addCents = formattedValue.replace(/^(\d+)(\d{2})$/, '$1.$2');
      categoryBudget.value = addCents;
      return addCents;
    };

    const updateCategory = () => {
      loadingText.value = 'Updating Category...';
      loading.value = true;
      updatedCategory.Budget = categoryBudget.value
        ? categoryBudget.value
        : store.editCategoryBudget.budget;

      if (
        Object.prototype.hasOwnProperty.call(
          store.editCategoryBudget,
          'subcategoryID'
        )
      ) {
        store.saveSubcategoryBudgetDataForMonth(updatedCategory).then(() => {
          loading.value = false;
          router.push({ name: 'Budget' });
        });
      } else {
        store.saveCategoryBudgetDataForMonth(updatedCategory).then(() => {
          loading.value = false;
          router.push({ name: 'Budget' });
        });
      }
    };

    const updateSubcategoryBudget = (subcategory, value) => {
      const subcategoryIndex = updatedCategory.Subcategories.findIndex(
        (item) => item.SubcategoryID === subcategory.subcategoryID
      );
      if (subcategoryIndex !== -1) {
        updatedCategory.Subcategories[subcategoryIndex].Budget = value;
      } else {
        updatedCategory.Subcategories.push({
          SubcategoryID: subcategory.subcategoryID,
          Name: subcategory.name,
          Budget: value,
          ParentCategoryID: subcategory.parentCategoryID,
          Month: store.editCategoryMonth,
          Year: store.editCategoryYear,
        });
      }
    };

    onMounted(() => {
      setTimeout(() => {
        const mainElement = document.querySelector('.main');
        if (mainElement) {
          mainElement.scrollTo(0, 0);
        }
      }, 100);

      categoryBudget.value = store.editCategoryBudget.budget;
      if (
        Object.prototype.hasOwnProperty.call(
          store.editCategoryBudget,
          'subcategoryID'
        )
      ) {
        updatedCategory = {
          SubcategoryID: store.editCategoryBudget.subcategoryID,
          parentCategoryID: store.editCategoryBudget.parentCategoryID,
          Name: store.editCategoryBudget.name,
          Month: store.editCategoryMonth,
          Year: store.editCategoryYear,
          Budget: categoryBudget.value,
        };
      } else {
        updatedCategory = {
          CategoryID: store.editCategoryBudget.categoryID,
          Name: store.editCategoryBudget.name,
          Month: store.editCategoryMonth,
          Year: store.editCategoryYear,
          Budget: categoryBudget.value,
          Subcategories: [],
        };
      }
      loading.value = false;
    });

    onUnmounted(() => {
      store.updateEditCategory({});
    });

    return {
      store,
      router,
      sliderOptions,
      sliderOptionUpdated,
      editCategoryBudgetSliderSelected,
      parseIconString,
      categoryName,
      formatMoneyInput,
      formatMoney,
      categoryBudget,
      formatMoneyRegex,
      updateCategory,
      updateSubcategoryBudget,
      loading,
      loadingText,
    };
  },
};
</script>

<style scoped>
.cat-info-card {
  padding: 1em;
  border-radius: 5px;
  box-shadow: 0px 20px 20px rgba(0, 0, 0, 0.1);
}

.light-theme .cat-info-card {
  background: #f8f8f8;
}

.dark-theme .cat-info-card {
  background: #212e3e;
  color: white;
}

.subcategorization-card {
  border-radius: 0.5em;
  margin-bottom: 1em;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  color: #004751;
}

.light-theme .edit-subcategorization-card {
  background: #f1f1f1;
}

.dark-theme .edit-subcategorization-card {
  background: #171e29;
  color: #d4d2d2;
  border: 1px solid #d4d2d2;
}

.light-theme .subcategorization-card i {
  color: #004751;
}

.dark-theme .subcategorization-card i {
  color: #d4d2d2;
}

.subcategory-list-wrapper {
  width: 100%;
}

.dark-theme .subcategory-list-wrapper {
  color: #d4d2d2;
  background: transparent;
  border: none;
  border-top: 1px solid #212e3e;
}

.edit-subcategory-list-wrapper {
  background: white;
  border: 1px solid #f1f1f1;
  padding: 10px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1);
}
.subcategory-item {
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1);
}

.light-theme .subcategory-item {
  border: 1px solid #f1f1f1;
}

.dark-theme .subcategory-item {
  background: #171e29;
  border: 1px solid #171e29;
}

.dropdown-padding {
  padding: 10px;
}

.category-color {
  height: 17px;
  width: 17px;
  border-radius: 50%;
}

.dark-theme .icon-wrapper:before,
.dark-theme .sub-icon-wrapper:before {
  background: #212e3e;
}

.icon-wrapper svg {
  display: block;
  position: relative;
  font-size: 14px;
  text-align: center;
  line-height: 30px;
}

.info-icon {
  color: #e8f44a;
}

.subcategory-label {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.subcategory-label .icon {
  color: #851e0d;
}

.subcategory-icon-width {
  flex: 0 0 30px;
}

.subcategory-name-width {
  flex: 0 0 50%;
}

.subcategory-budget-width {
  flex: 1;
  text-align: right;
}

.budget-text {
  font-size: 0.8em;
}

.budget-value {
  font-weight: 600;
  font-size: 1em;
  text-align: right;
}

.budget-value input {
  text-align: right;
}
</style> -->
